export const DIGITED_CODE_MAX_LENGTH = 100;
